<template>
	<div class="webContent flex" scroll @scroll="listenScroll">
		<div class="mine">
			<div class="area df hao jcb">
				<div class="classify df hao">{{classify}}</div>
				<div>{{list.length}}个内容</div>
			</div>
			<div class="list">
				<div class="li" v-for="(v,i) in list">
					<div class="item" @click="toDetail(v)" v-if="v.types==1">
						<div class="title"><i v-if="v.question.announcement==1" class="rule"></i><i v-if="v.question.refining==1" class="prize"></i><i v-if="v.question.top==1" class="top"></i>{{v.question.title}}</div>
						<div class="txt ov-4d" v-html="v.question.content">{{v.question.content}}</div>
						<div class="end df hao">
							<div class="like" :class="{ has: v.question.approval!=0 }" @click.stop.prevent="likeItem(v.question.id,v.question.approval,1,v.question)">{{v.question.approvalTotal}}</div>
							<div class="collect has" @click.stop.prevent="collectItem(v.id,i)">{{v.question.collectionTotal}}</div>
							<div class="flex"></div>
							<div class="user">{{v.question.creatorName||''}}</div>
							<div class="date">{{dateTime(v.question.createTime)}}</div>
						</div>
					</div>
					<div class="item" @click="toDetail(v)" v-else-if="v.types==2">
						<div class="title"><i v-if="v.answer.announcement==1" class="rule"></i><i v-if="v.answer.refining==1" class="prize"></i><i v-if="v.answer.top==1" class="top"></i>{{v.answer.title}}</div>
						<div class="txt ov-4d" v-html="v.answer.content">{{v.answer.content}}</div>
						<div class="end df hao">
							<div class="like" :class="{ has: v.answer.approval!=0 }" @click.stop.prevent="likeItem(v.answer.id,v.answer.approval,2,v.answer)">{{v.answer.approvalTotal}}</div>
							<div class="collect has" @click.stop.prevent="collectItem(v.id,i)">{{v.answer.collectionTotal}}</div>
							<div class="flex"></div>
							<div class="user">{{v.answer.creatorName||''}}</div>
							<div class="date">{{dateTime(v.answer.createTime)}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'me_collectList_page',
		data () {
			return {
				cid: '',
				classify: '',
				pagenum: 1,
				pagesize: 10,
				state: false,
				list: [],
			}
		},
		mounted(){
			this.cid = this.$route.query.id;
			this.classify = this.$route.query.name;
			this.getList();
		},
		methods: {
			dateTime(timestamp){
				if(!timestamp){ return ''; }
				var date = new Date(timestamp);
				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			listenScroll(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData();
				}
			},
			addMoreData() { //加载更多
				if(this.state){
					return false;
				}
				this.pagenum ++;
				this.getList();
			},
			getList(){
				this.state = true;

				this.h5Ajax('get','$/favorites/detail',{
					id: this.cid,
					page: this.pagenum,
					size: this.pagesize,
				}).then(r=>{
					if(r.contents.content.length>0){
						for(var i in r.contents.content){
							var d = r.contents.content[i];
							this.list.push(d);
						}
						this.state = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			collectItem(id,index){
				this.h5Ajax('post','$/collections/cancel',{
					id: id,
				}).then(r=>{
					// this.pagenum = 1;
					// this.state = false;
					// this.list = [];
					// this.getList();
					this.list.splice(index,1);
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			likeItem(id,wid,nav,item){
				if(wid>0){
					this.h5Ajax('post','$/approvals/cancel',{
						id: wid,
					}).then(r=>{
						// this.pagenum = 1;
						// this.state = false;
						// this.list = [];
						// this.getList();
						item.approval = 0;
						item.approvalTotal --;
					})
				}else{
					this.h5Ajax('post','$/approvals/add',{
						approvalId: id,
						types: nav,
					}).then(r=>{
						// this.pagenum = 1;
						// this.state = false;
						// this.list = [];
						// this.getList();
						item.approval = r.id;
						item.approvalTotal ++;
					})
				}
			},
			toDetail(data){
				this.$router.replace({ path: '/model/detail', query: { id: data.question.id } });
			},
		},
	}
</script>

<style scoped>
	@import './collectList'
</style>



// WEBPACK FOOTER //
// src/app/pages/me/collectList/collectList.vue